import Vue from 'vue'
import Router from 'vue-router'
import Index from '@/pages/index/index'
// import BusinessCooperation from '@/pages/businessCooperation/businessCooperation'
import ProductService from '@/pages/productService/index'
import About from '@/pages/about/index'
import QXB from '@/pages/QXB/index'
import CloudWarehouse from '@/pages/cloudWarehouse/index'
import DockingService from '@/pages/dockingService/index'

Vue.use(Router)

export default new Router({
  routes: [
    {
      path: '/',
      name: 'index',
      component: Index,
      redirect: '/index'
    },
    {
      path: '/index',
      name: 'index',
      component: Index
    },
    // {
    //   path: '/businessCooperation',
    //   component: BusinessCooperation,
    //   name: 'businessCooperation'
    // },
    {
      path: '/productService',
      component: ProductService,
      name: 'productService'
    },
    {
      path: '/about',
      component: About,
      name: 'about'
    },
    {
      path: '/articleList',
      component: () => import('@/pages/articleList/index.vue'),
      name: 'articleList'
    },
    {
      path: '/QXB',
      component: QXB,
      name: 'QXB'
    },
    {
      path: '/cloudWarehouse',
      component: CloudWarehouse,
      name: 'cloudWarehouse'
    },
    {
      path: '/dockingService',
      component: DockingService,
      name: 'dockingService'
    },
  ],
  scrollBehavior (to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition
    } else {
      return { x: 0, y: 0 }
    }
  }
})



// WEBPACK FOOTER //
// ./src/router/index.js